export const ACCESS_TOKEN_KEY_NAME = 'access_token'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api'

export const USER_GUIDE_URL =
  'https://stakeholder-map.nyc3.cdn.digitaloceanspaces.com/new-rolodex-user-guide.pdf'

// Environment variables
export const ENV = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  NODE_ENV: import.meta.env.NODE_ENV,
  DEV: import.meta.env.DEV,
  PROD: import.meta.env.PROD,
  CLIENT_KEY: import.meta.env.VITE_CLIENT_KEY,
  PROFILE_URL: import.meta.env.VITE_PROFILE_URL,
} as const